export enum MapSaveImageTypeEnum {
  PNG_SNAPSHOT = 'png',
  PNG_RAW = 'png-raw',
  TIFF = 'tiff',
  OBLIQUE = 'oblique',
}
export enum MapSaveImageTypeByProviderEnum {
  PNG = 'png',
  TIFF = 'tiff',
}

export enum MapSaveImageObliqueDirectionEnum {
  NORTH = 'oblique-north',
  SOUTH = 'oblique-south',
  EAST = 'oblique-east',
  WEST = 'oblique-west',
}

export enum MapSaveImageQualityEnum {
  BASE = 'base',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export enum VexcelDownloadTypeEnum {
  API = 'api',
  SNAPSHOT = 'snapshot',
}

export const VexcelDownloadTypeLabels: Record<VexcelDownloadTypeEnum, string> = {
  [VexcelDownloadTypeEnum.API]: 'Server Export (no layers, with configuration)',
  [VexcelDownloadTypeEnum.SNAPSHOT]: 'Screenshot (all what you see)',
};
